import React from 'react';
import './QuizResult.css';

function getRank(pct) {
  if (pct === 100) return { label: 'Perfect!', color: 'var(--accent-gold)', icon: '&#127942;' };
  if (pct >= 80) return { label: 'Excellent!', color: 'var(--accent-green)', icon: '&#11088;' };
  if (pct >= 60) return { label: 'Good Job!', color: 'var(--accent-blue)', icon: '&#128077;' };
  return { label: 'Keep Practicing', color: 'var(--accent-purple)', icon: '&#128170;' };
}

export default function QuizResult({ result, topic, navigate }) {
  if (!result) { navigate('lessons'); return null; }

  const rank = getRank(result.percentage);
  const pct = Math.round(result.percentage);

  return (
    <div className="result-wrap animate-in">
      <div className="result-card card">
        <div className="result-rank" style={{ color: rank.color }}>
          <span className="result-rank-icon" dangerouslySetInnerHTML={{ __html: rank.icon }} />
          <span className="result-rank-label">{rank.label}</span>
        </div>

        <div className="result-circle" style={{ '--pct': pct, '--color': rank.color }}>
          <svg className="result-svg" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r="50" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="10" />
            <circle
              cx="60" cy="60" r="50" fill="none"
              stroke={rank.color}
              strokeWidth="10"
              strokeLinecap="round"
              strokeDasharray={`${2 * Math.PI * 50}`}
              strokeDashoffset={`${2 * Math.PI * 50 * (1 - pct / 100)}`}
              style={{ transform: 'rotate(-90deg)', transformOrigin: '60px 60px', transition: 'stroke-dashoffset 1s ease' }}
            />
          </svg>
          <div className="result-pct-inner">
            <span className="result-pct">{pct}%</span>
            <span className="result-pct-label">Score</span>
          </div>
        </div>

        <h2 className="result-title">{topic?.title} Complete</h2>

        <div className="result-stats">
          <div className="result-stat">
            <span className="rs-value" style={{ color: 'var(--accent-green)' }}>{result.correct}</span>
            <span className="rs-label">Correct</span>
          </div>
          <div className="result-stat">
            <span className="rs-value" style={{ color: 'var(--accent-red)' }}>{result.total - result.correct}</span>
            <span className="rs-label">Wrong</span>
          </div>
          <div className="result-stat">
            <span className="rs-value" style={{ color: 'var(--accent-gold)' }}>+{result.xp_earned}</span>
            <span className="rs-label">XP Earned</span>
          </div>
        </div>

        {result.bonus_xp > 0 && (
          <div className="bonus-xp-banner">
            &#11088; Perfect Score Bonus: +{result.bonus_xp} XP
          </div>
        )}
      </div>

      {result.results && result.results.length > 0 && (
        <div className="result-breakdown card">
          <h3 className="section-title" style={{ fontSize: '1rem', marginBottom: 16 }}>Answer Review</h3>
          <div className="breakdown-list">
            {result.results.map((r, i) => (
              <div key={i} className={`breakdown-item ${r.correct ? 'correct' : 'wrong'}`}>
                <span className="breakdown-icon">{r.correct ? '&#10003;' : '&#10007;'}</span>
                <div className="breakdown-body">
                  <div className="breakdown-label">Question {i + 1}</div>
                  <div className="breakdown-explanation">{r.explanation}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="result-actions">
        <button className="btn btn-secondary" onClick={() => navigate('quiz', topic)}>
          Retry Quiz
        </button>
        <button className="btn btn-primary" onClick={() => navigate('lessons')}>
          Back to Topics
        </button>
        <button className="btn btn-secondary" onClick={() => navigate('achievements')}>
          View Achievements
        </button>
      </div>
    </div>
  );
}
